import React from 'react';
import {
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import Root from './Root';
import {
  nonAuthRoutes,
  routeProps,
  routes,
} from './Constants';
import { BaseProps } from '../utils/types';
import { RoleBaseNavigation } from './roleBaseNavigation';

const Routes: React.FC<BaseProps> = (props) => {
  const createProtectedRoute = (route: routeProps) => {
    return {
      path: route.path,
      element: (
        <ProtectedRoute
          requiredRoles={route.roles}
          userRoles={props.authUser.actorType}
          element={<route.element {...props} />}
        />
      ),
    };
  };

  const createRoute = (route: routeProps) => {
    return {
      path: route.path,
      element: <route.element {...props} />,
    };
  };

  const createRoutes = (routes: routeProps[]) => {
    const routesList: {
      path: string;
      element: React.JSX.Element;
    }[] = [];
    routes.forEach((route) => {
      if (route.protected) {
        routesList.push(createProtectedRoute(route));
      } else {
        routesList.push(createRoute(route));
      }
    });
    return routesList;
  };
  const routeConfig = [
    ...(props.authUser?.actorType
      ? [
          {
            path: '/',
            element: <Root />,
            children: createRoutes(routes),
          },
        ]
      : nonAuthRoutes),
    {
      path: '*',
      element: <RoleBaseNavigation {...props} />,
    },
  ];

  const router = createBrowserRouter(routeConfig);
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default Routes;
